import { Account } from './types';

export const globalAccounts: Account[] = [
    // ========================================
    // 1️⃣ ASET (ASSETS)
    // ========================================

    // 1101 - KAS
    {
        id: 'ACC-1101',
        code: '1101',
        name: 'Kas',
        type: 'asset',
        category: 'asset',
        subCategory: 'Kas',
        balanceType: 'debit',
        balance: 'Rp 22.730.000',
        status: 'active',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-1101-001',
        code: '1101-001',
        name: 'Kas IDR (Petty Cash)',
        type: 'asset',
        category: 'asset',
        subCategory: 'Kas',
        balanceType: 'debit',
        balance: 'Rp 10.030.000',
        status: 'active',
        parentId: 'ACC-1101',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-1101-002',
        code: '1101-002',
        name: 'Kas USD',
        type: 'asset',
        category: 'asset',
        subCategory: 'Kas',
        balanceType: 'debit',
        balance: 'Rp 9.300.000',
        status: 'active',
        parentId: 'ACC-1101',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-1101-003',
        code: '1101-003',
        name: 'Kas SGD',
        type: 'asset',
        category: 'asset',
        subCategory: 'Kas',
        balanceType: 'debit',
        balance: 'Rp 3.400.000',
        status: 'active',
        parentId: 'ACC-1101',
        createdAt: '2025-01-01',
    },

    // 1102 - BANK
    {
        id: 'ACC-1102',
        code: '1102',
        name: 'Bank',
        type: 'asset',
        category: 'asset',
        subCategory: 'Bank',
        balanceType: 'debit',
        balance: 'Rp 951.868.572',
        status: 'active',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-1102-001',
        code: '1102-001',
        name: 'Bank Mandiri IDR',
        type: 'asset',
        category: 'asset',
        subCategory: 'Bank',
        balanceType: 'debit',
        balance: 'Rp 109.478.296',
        status: 'active',
        parentId: 'ACC-1102',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-1102-002',
        code: '1102-002',
        name: 'Bank BCA IDR',
        type: 'asset',
        category: 'asset',
        subCategory: 'Bank',
        balanceType: 'debit',
        balance: 'Rp 780.066.563',
        status: 'active',
        parentId: 'ACC-1102',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-1102-003',
        code: '1102-003',
        name: 'Bank Danamon USD',
        type: 'asset',
        category: 'asset',
        subCategory: 'Bank',
        balanceType: 'debit',
        balance: 'Rp 57.660.000',
        status: 'active',
        parentId: 'ACC-1102',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-1102-004',
        code: '1102-004',
        name: 'Bank Panin SGD',
        type: 'asset',
        category: 'asset',
        subCategory: 'Bank',
        balanceType: 'debit',
        balance: 'Rp 4.663.712',
        status: 'active',
        parentId: 'ACC-1102',
        createdAt: '2025-01-01',
    },

    // 1103 - PIUTANG
    {
        id: 'ACC-1103',
        code: '1103',
        name: 'Piutang',
        type: 'asset',
        category: 'asset',
        subCategory: 'Piutang',
        balanceType: 'debit',
        balance: 'Rp 45.116.100',
        status: 'active',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-1103-001',
        code: '1103-001',
        name: 'Piutang Siswa (SPP)',
        type: 'asset',
        category: 'asset',
        subCategory: 'Piutang',
        balanceType: 'debit',
        balance: 'Rp 35.116.100',
        status: 'active',
        parentId: 'ACC-1103',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-1103-002',
        code: '1103-002',
        name: 'Piutang Lainnya',
        type: 'asset',
        category: 'asset',
        subCategory: 'Piutang',
        balanceType: 'debit',
        balance: 'Rp 10.000.000',
        status: 'active',
        parentId: 'ACC-1103',
        createdAt: '2025-01-01',
    },

    // ========================================
    // 2️⃣ LIABILITAS (KEWAJIBAN)
    // ========================================

    // 2101 - UTANG OPERASIONAL
    {
        id: 'ACC-2101',
        code: '2101',
        name: 'Utang Operasional',
        type: 'liability',
        category: 'liability',
        subCategory: 'Utang Operasional',
        balanceType: 'credit',
        balance: 'Rp 25.000.000',
        status: 'active',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-2101-001',
        code: '2101-001',
        name: 'Utang Gaji',
        type: 'liability',
        category: 'liability',
        subCategory: 'Utang Operasional',
        balanceType: 'credit',
        balance: 'Rp 15.000.000',
        status: 'active',
        parentId: 'ACC-2101',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-2101-002',
        code: '2101-002',
        name: 'Utang Vendor',
        type: 'liability',
        category: 'liability',
        subCategory: 'Utang Operasional',
        balanceType: 'credit',
        balance: 'Rp 10.000.000',
        status: 'active',
        parentId: 'ACC-2101',
        createdAt: '2025-01-01',
    },

    // ========================================
    // 3️⃣ EKUITAS
    // ========================================

    {
        id: 'ACC-3101',
        code: '3101',
        name: 'Modal Yayasan',
        type: 'equity',
        category: 'equity',
        subCategory: 'Modal',
        balanceType: 'credit',
        balance: 'Rp 2.500.000.000',
        status: 'active',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-3102',
        code: '3102',
        name: 'Surplus / Defisit Ditahan',
        type: 'equity',
        category: 'equity',
        subCategory: 'Laba Ditahan',
        balanceType: 'credit',
        balance: 'Rp 850.000.000',
        status: 'active',
        createdAt: '2025-01-01',
    },

    // ========================================
    // 4️⃣ PENDAPATAN
    // ========================================

    // 4101 - PENDAPATAN PENDIDIKAN
    {
        id: 'ACC-4101',
        code: '4101',
        name: 'Pendapatan Pendidikan',
        type: 'income',
        category: 'income',
        subCategory: 'Pendapatan Pendidikan',
        balanceType: 'credit',
        balance: 'Rp 1.625.000.000',
        status: 'active',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-4101-001',
        code: '4101-001',
        name: 'Pendapatan SPP',
        type: 'income',
        category: 'income',
        subCategory: 'Pendapatan Pendidikan',
        balanceType: 'credit',
        balance: 'Rp 1.200.000.000',
        status: 'active',
        parentId: 'ACC-4101',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-4101-002',
        code: '4101-002',
        name: 'Uang Pangkal',
        type: 'income',
        category: 'income',
        subCategory: 'Pendapatan Pendidikan',
        balanceType: 'credit',
        balance: 'Rp 350.000.000',
        status: 'active',
        parentId: 'ACC-4101',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-4101-003',
        code: '4101-003',
        name: 'Donasi',
        type: 'income',
        category: 'income',
        subCategory: 'Pendapatan Pendidikan',
        balanceType: 'credit',
        balance: 'Rp 75.000.000',
        status: 'active',
        parentId: 'ACC-4101',
        createdAt: '2025-01-01',
    },

    // ========================================
    // 5️⃣ BIAYA (BEBAN)
    // ========================================

    // 5101 - BEBAN SDM
    {
        id: 'ACC-5101',
        code: '5101',
        name: 'Beban SDM',
        type: 'expense',
        category: 'expense',
        subCategory: 'Beban SDM',
        balanceType: 'debit',
        balance: 'Rp 900.000.000',
        status: 'active',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-5101-001',
        code: '5101-001',
        name: 'Gaji Guru',
        type: 'expense',
        category: 'expense',
        subCategory: 'Beban SDM',
        balanceType: 'debit',
        balance: 'Rp 650.000.000',
        status: 'active',
        parentId: 'ACC-5101',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-5101-002',
        code: '5101-002',
        name: 'Gaji Staff',
        type: 'expense',
        category: 'expense',
        subCategory: 'Beban SDM',
        balanceType: 'debit',
        balance: 'Rp 250.000.000',
        status: 'active',
        parentId: 'ACC-5101',
        createdAt: '2025-01-01',
    },

    // 5102 - BEBAN OPERASIONAL
    {
        id: 'ACC-5102',
        code: '5102',
        name: 'Beban Operasional',
        type: 'expense',
        category: 'expense',
        subCategory: 'Beban Operasional',
        balanceType: 'debit',
        balance: 'Rp 85.000.000',
        status: 'active',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-5102-001',
        code: '5102-001',
        name: 'Listrik',
        type: 'expense',
        category: 'expense',
        subCategory: 'Beban Operasional',
        balanceType: 'debit',
        balance: 'Rp 35.000.000',
        status: 'active',
        parentId: 'ACC-5102',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-5102-002',
        code: '5102-002',
        name: 'Air',
        type: 'expense',
        category: 'expense',
        subCategory: 'Beban Operasional',
        balanceType: 'debit',
        balance: 'Rp 15.000.000',
        status: 'active',
        parentId: 'ACC-5102',
        createdAt: '2025-01-01',
    },
    {
        id: 'ACC-5102-003',
        code: '5102-003',
        name: 'ATK',
        type: 'expense',
        category: 'expense',
        subCategory: 'Beban Operasional',
        balanceType: 'debit',
        balance: 'Rp 35.000.000',
        status: 'active',
        parentId: 'ACC-5102',
        createdAt: '2025-01-01',
    },
];
